import React, { Component } from "react";
import "../App.css";
import Toolbar from "./Toolbar/Toolbar";
import SideDrawer from "./SideDrawer/SideDrawer";
import Backdrop from "./Backdrop/Backdrop";

export default class HeaderPage extends Component {
  state = {
    sideDrawerOpen: false,
  };
  drawerToggleClickHandler = () => {
    this.setState((prevState) => {
      return { sideDrawerOpen: !prevState.sideDrawerOpen };
    });
  };
  backdropClickHandler = () => {
    this.setState({ sideDrawerOpen: false });
  };

  render() {
    let backdrop;
    if (this.state.sideDrawerOpen) {
      backdrop = <Backdrop click={this.backdropClickHandler} />;
    }
    return (
      <>
        <section
          className="hero is-medium is-bold backgroundImage1"
          style={{ height: "auto", width: "100%" }}
        >
          <Toolbar drawerClickHandle={this.drawerToggleClickHandler} />
          <SideDrawer show={this.state.sideDrawerOpen} />
          {backdrop}
          <div className="hero-body mt-md-5">
            <div className="columns is-centered is-vcentered">
              <div className="column is-12 mt-md-5">
                <div
                  className="container has-text-centered"
                  style={{ margin: "auto" }}
                >
                  <h1
                    style={{ lineHeight: "2rem" }}
                    className="title colorWhite"
                  >
                    Don't know what tool is best for you?
                  </h1>
                  <hr className="hr1" />
                  <div className="subtitle colorWhite ">
                    <p>
                      {" "}
                      Choosing the right tools can significantly improve
                      developer productivity.{" "}
                    </p>
                    <hr className="hr2" />
                    <p>
                      {" "}
                      Check out the award-winning professional developer tools
                      from JetBrains.
                    </p>
                    <hr className="hr2" />
                    <p>
                      {" "}
                      <a
                        href="mailto:reachus@codeops.tech"
                        className="colorWhite"
                      >
                        {" "}
                        <span className="reach-out">Reach out to us</span>{" "}
                      </a>{" "}
                      for purchasing licenses.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="columns is-centered is-vcentered">
              <div className="coulmn is-3 has-text-centered mt-md-5">
                <a
                  href="https://www.jetbrains.com/company/partners/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{ maxWidth: "350px" }}
                    src="https://image-dock-uploads-be.s3.ap-south-1.amazonaws.com/image.2021-07-08T06%3A43%3A51.924Z"
                    alt="jetbrain partners logo"
                  />
                </a>
              </div>
              <div className="coulmn is-3 has-text-centered mt-md-5">
                <a
                  href="https://www.jetbrains.com/company/resellers/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{ maxWidth: "350px" }}
                    src={`${process.env.PUBLIC_URL}/images/premiumReseller.png`}
                    alt="jetbrain resellers logo"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="box">
            <p className="has-text-centered ">
              <b>
                Whichever technologies you use, there's a JetBrains tool to
                match.{" "}
              </b>
            </p>
          </div>
        </section>
      </>
    );
  }
}
